// 足球 世界杯赛
export default {
  data() {
    return {
      containerFullClassName: 'containerFull_football_cup',
      defaultPath: ['football', 'FIFAWorldCup', 'schedule'],
      axiosBaseUrl: '/ftcup',
      sportCompetitionType: 'football_FIFAWorldCup', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['1092026','1092022', '1092018'],
          themeIndex: 0,
        },
      ],
    }
  },
}
